



















import { Vue, Component } from 'vue-property-decorator'
import SearchFilter from '@/components/search-filter.vue'
import SortHeader from '@/components/SortHeader.vue'
import okxService from '@/services/okxService'
import utility from '@/common/utility'

@Component({ components: { SortHeader, SearchFilter } })
export default class Okx extends Vue {
  model: [] = []
  loading = false
  coin = ''

  async mounted () {
    await this.load('BTC')
  }

  async load (coin: string) {
    this.model = []
    this.loading = true
    const res = await okxService.getBalances(coin)
    utility.freezeArrayAndItems(res.Result)
    this.model = res.Result
    this.loading = false
  }
}
